import React from "react";
import { TemplateClassNames } from "../../../../types/template-layouts";
import { ModuleMap, PageModule, PageModuleType } from "../../../../types/working-model";
import "./blank-section.scss";


interface Props {
	module: PageModule;
	template?: TemplateClassNames;
}

const BlankSection: React.FC<Props> = React.forwardRef<HTMLDivElement, Props>(({ module }, ref) => {

	const content = module?.content ?? { html: '' };

	return module.is_on ? (
		<div
			id={ModuleMap[PageModuleType.blank]}
			className="blank-section"
			ref={ref}
		>
			<div className="module-container" dangerouslySetInnerHTML={{ __html: content?.html }}>
			</div>
		</div>
	) : null;
});

// When using forwardRef with an anonymous function we need to define a displayName.
// This specific component doesnt throw an error without defining a displayName,
// however including this line just incase something changes in the future. 
// This is also following the same pattern as the rest of the forwardRefs 
// we use on the other PageModule components.
BlankSection.displayName = 'BlankSection';

export default BlankSection;
